import type {
    BindOrderTaskRequest,
    CancelTaskRequest,
    OrderTaskApiFindOrderForTaskRequest,
    PayForTaskRequest,
} from '@/core/generated/api';
import type { TaskActionFormValues, TaskBindingFormValues, TaskOrderSearchValues } from './model/schema';

/** Формирует запрос привязки выбранного заказа к сделке */
export const taskBindingToRequest = (
    values: TaskBindingFormValues,
    taskId: number
): BindOrderTaskRequest => ({
    taskId,
    orderId: values.orderId,
});

/** Формирует один точный критерий поиска заказа */
export const taskOrderSearchToRequest = (
    values: TaskOrderSearchValues
): OrderTaskApiFindOrderForTaskRequest => (
    values.mode === 'id'
        ? { orderId: values.query }
        : { orderNumber: Number(values.query) }
);

/** Формирует запрос отмены сделки из комментария администратора */
export const taskActionToCancelRequest = (
    values: TaskActionFormValues,
    taskId: number
): CancelTaskRequest => ({
    taskId,
    comment: values.comment.trim(),
});

/** Формирует запрос выплаты исполнителю из комментария администратора */
export const taskActionToPayRequest = (
    values: TaskActionFormValues,
    taskId: number
): PayForTaskRequest => ({
    taskId,
    comment: values.comment.trim(),
});
